/* eslint-disable @typescript-eslint/no-require-imports */
import type { SearchClassificationService } from "$src/core/services/search-classification/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => SearchClassificationService>({
  native: () => require("./search-classification").default,
  default: () => require("./static-lookup/static-lookup").default,
})();
